import { UserAgentApplication } from 'msal';

const clientId = '368b5536-9bdd-40a3-8068-d632b19b0c22';
const msalInstance = new UserAgentApplication({
  auth: {
    clientId,
    redirectUri: `${location.origin}/auth`,
  },
});
const tokenRequest = {
  scopes: [`api://${clientId}/Profile.Read`],
};

msalInstance.handleRedirectCallback(() => {});

function getFromStorage(): string {
  const [key] = Object.keys(sessionStorage).filter((key) => key.startsWith('{"authority":'));
  const value = key && JSON.parse(sessionStorage.getItem(key));

  if (value && new Date(value.expiresIn * 1000) > new Date()) {
    return value.accessToken;
  }
}

function getFromService() {
  return msalInstance
    .acquireTokenSilent(tokenRequest)
    .then((response) => response.accessToken)
    .catch((err) => {
      if (err.name === 'InteractionRequiredAuthError') {
        return msalInstance
          .acquireTokenPopup(tokenRequest)
          .then((response) => response.accessToken)
          .catch((err) => Promise.reject(err && err.message));
      }

      console.error(err);
      return Promise.reject('Could not fetch token');
    });
}

export function getToken(): Promise<string> {
  const token = getFromStorage();

  if (token) {
    return Promise.resolve(token);
  } else if (account()) {
    return getFromService();
  }

  return Promise.reject('Not logged in');
}

export function getAuthHeader() {
  return getToken().then((token) => `Bearer ${token}`);
}

export function account() {
  return msalInstance.getAccount();
}

export function login() {
  msalInstance.loginRedirect(tokenRequest);
}

export function logout() {
  msalInstance.logout();
}

export function changed() {
  // empty on purpose
}

export const providers = ['microsoft'];
